import ScreenError from './ScreenError';

export default ScreenError;
